/* src/app/member/member.component.scss */
.company-title {
  display: inline;
}
/*# sourceMappingURL=member.component.css.map */
